export default __webpack_public_path__ + "static/media/house-regular-full.b8dcb225.svg";